import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { unescapeData } from '@root/src/lib/escapeData';
import { css } from '@emotion/react';
import { textSans } from '@guardian/src-foundations/typography';
import { text } from '@guardian/src-foundations/palette';
const emailCaptionStyle = css `
	${textSans.xxsmall()};
	word-break: break-all;
	color: ${text.supporting};
`;
const embedContainer = css `
	iframe {
		/* Some embeds can hijack the iframe and calculate an incorrect width, which pushes the body out */
		width: 100% !important;
	}
`;
export const EmbedBlockComponent = ({ html, caption }) => {
    // TODO: Email embeds are being turned into atoms, so we can remove this hack when that happens
    const isEmailEmbed = html.includes('email/form');
    return (_jsxs("div", Object.assign({ "data-cy": "embed-block", css: embedContainer }, { children: [_jsx("div", { dangerouslySetInnerHTML: { __html: unescapeData(html) } }, void 0),
            isEmailEmbed && caption && (_jsx("div", Object.assign({ css: emailCaptionStyle }, { children: caption }), void 0))] }), void 0));
};
